import React, { useEffect, useState } from 'react';
import { Checkbox, Col, Form, Input, Modal, Row, Select, Switch } from 'antd';
import { CountryCode, IdentificationTypes } from '../../interfaces/card-holder';
import { Countries } from '../../constants';

type IdentificationsFormInputs = {
  type: IdentificationTypes;
  number: string;
  country: CountryCode;
  registeredVatPayer: boolean;
};

interface IdentificationCreateFormProps {
  open: boolean;
  onCreate: (values: IdentificationsFormInputs) => void;
  onCancel: () => void;
  identification?: IdentificationsFormInputs | undefined;
}

const ModalIdentification: React.FC<IdentificationCreateFormProps> = ({ open, onCreate, onCancel, identification }) => {
  const [form] = Form.useForm();
  const [registeredVatPayer, setRegisteredVatPayer] = useState<boolean>(identification ? identification?.registeredVatPayer : false );

  useEffect(() => {
    if(identification) {
      form.setFieldValue("type", identification?.type);
      form.setFieldValue("number", identification?.number);
      form.setFieldValue("country", identification?.country);
      setRegisteredVatPayer(identification?.registeredVatPayer);
    }
  }, [identification]);

  return (
    <Modal
      open={open}
      title={identification ? 'Modificar identificación' : 'Crear nueva identificación'}
      okText={identification ? 'Modificar' : 'Crear'}
      cancelText="Cancelar"
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      onOk={() => {
        form
          .validateFields()
          .then((values: IdentificationsFormInputs) => {
            form.resetFields();
            values.registeredVatPayer = registeredVatPayer;
            onCreate(values);
          })
          .catch((info) => {
            console.error('Validate Failed:', info);
          });
      }}
    >

      <Form form={form} layout="vertical" name="form_in_modal">
        <Row gutter={24}>
          <Col flex="auto">
            <Form.Item<IdentificationsFormInputs>
              name="country"
              label="Pais"
              rules={[{ required: true, message: 'Por favor ingresar pais.' }]}
            >
              <Select
                placeholder="Seleccionar pais"
                showSearch
                options={Object.entries(Countries).map(([code, name]) => ({ label: name, value: code }))}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item<IdentificationsFormInputs>
              name="type"
              label="Tipo"
              rules={[{ required: true, message: 'Por favor seleccionar una opcion.' }]}
            >
              <Select
                placeholder="Seleccionar tipo"
                showSearch
                options={Object.values(IdentificationTypes).map((type) => ({ label: type, value: type }))}
              />
            </Form.Item>
          </Col>
          <Col flex="auto">
            <Form.Item<IdentificationsFormInputs>
              name="number"
              label="Numero"
              rules={[{ required: true, message: 'Por favor ingresar valor.' }]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item<IdentificationsFormInputs>
          name="registeredVatPayer"
          label="Es usted Responsable Inscripto?"
          layout="horizontal"
        >
          <Checkbox checked={registeredVatPayer} onChange={() => setRegisteredVatPayer(!registeredVatPayer) } />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalIdentification;
